export const JobForm_Page_Data = {
    "area-sales-manager-3": {
        // Page Meta Fields
        META_PG_OG_Title: 'Area Sales Manager | Marvel Blinds',
        META_PG_OG_Description: 'Candidate with more than 4+ years of experience in appointing channel partners, have good contact with Architect/Interior designer can apply',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/area-sales-manager-3/`,

        Job_TITLE: "Area Sales Manager",
        Job_DESCRIPTION: "Candidate with more than 4+ years of experience in appointing channel partners, have good contact with Architect/Interior designer can apply"
    },
    "area-sales-manager-2": {
        // Page Meta Fields
        META_PG_OG_Title: 'Area Sales Manager | Marvel Blinds',
        META_PG_OG_Description: 'Candidate with more than 4+ years of experience in appointing channel partners, have good contact with Architect/Interior designer can apply',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/area-sales-manager-2/`,

        Job_TITLE: "Area Sales Manager",
        Job_DESCRIPTION: "Candidate with more than 4+ years of experience in appointing channel partners, have good contact with Architect/Interior designer can apply"
    },
    "area-sales-manager": {
        // Page Meta Fields
        META_PG_OG_Title: 'Area Sales Manager | Marvel Blinds',
        META_PG_OG_Description: 'Candidate with more than 4+ years of experience in appointing channel partners, have good contact with Architect/Interior designer can apply',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/area-sales-manager/`,

        Job_TITLE: "Area Sales Manager",
        Job_DESCRIPTION: "Candidate with more than 4+ years of experience in appointing channel partners, have good contact with Architect/Interior designer can apply"
    },
    "dgm-sales-marketing": {
        // Page Meta Fields
        META_PG_OG_Title: 'DGM-Sales & Marketing | Marvel Blinds',
        META_PG_OG_Description: 'Strong channel sales experience with more than 10+ years of experience',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/dgm-sales-marketing/`,

        Job_TITLE: "DGM-Sales & Marketing",
        Job_DESCRIPTION: "Strong channel sales experience with more than 10+ years of experience",
    },
    "sales-coordinator": {
        // Page Meta Fields
        META_PG_OG_Title: 'Sales Coordinator | Marvel Blinds',
        META_PG_OG_Description: 'Candidate with 2+ years of experience in coordination with channel partners/sales team and can generate the leads.',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/sales-coordinator/`,

        Job_TITLE: "Sales Coordinator",
        Job_DESCRIPTION: "Candidate with 2+ years of experience in coordination with channel partners/sales team and can generate the leads.",
    },
    "bdm-inside-sales": {
        // Page Meta Fields
        META_PG_OG_Title: 'BDM- Inside Sales | Marvel Blinds',
        META_PG_OG_Description: 'Candidate having 5+ years of experience in business development, lead generation, cold calling can apply.',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/bdm-inside-sales/`,

        Job_TITLE: "BDM- Inside Sales",
        Job_DESCRIPTION: "Candidate having 5+ years of experience in business development, lead generation, cold calling can apply.",
    },
    "bde-inside-sales": {
        // Page Meta Fields
        META_PG_OG_Title: 'BDE-Inside Sales | Marvel Blinds',
        META_PG_OG_Description: 'Candidate having 2+ years of experience in business development, lead generation, cold calling can apply.  ',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/job/bde-inside-sales/`,

        Job_TITLE: "BDE-Inside Sales",
        Job_DESCRIPTION: "Candidate having 2+ years of experience in business development, lead generation, cold calling can apply.",
    }
}